import { useEffect, useState } from 'react';
import bundledArticles from '../data/articles.json';

let cachePromise = null;

const sortArticles = (articles) =>
    articles.slice().sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));

function loadRuntimeArticles() {
    if (cachePromise) return cachePromise;

    // Carga los artículos publicados desde el JSON en tiempo real.
    // Si falla (red, servidor), usa los artículos incluidos en el build.
    cachePromise = fetch(`/data/articles.json?v=${Date.now()}`, { cache: 'no-store' })
        .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        })
        .then((data) => (Array.isArray(data) && data.length > 0 ? data : bundledArticles))
        .catch(() => bundledArticles)
        .finally(() => {
            cachePromise = null;
        });

    return cachePromise;
}

/**
 * Hook que devuelve los artículos del blog.
 * - `ready`: false mientras se cargan los artículos remotos.
 * - `articles`: artículos disponibles (remotos o los del build).
 */
const useArticles = () => {
    const [articles, setArticles] = useState(sortArticles(bundledArticles));
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let mounted = true;

        loadRuntimeArticles().then((data) => {
            if (mounted) {
                setArticles(sortArticles(data));
                setReady(true);
            }
        });

        return () => {
            mounted = false;
        };
    }, []);

    return { articles, ready };
};

export default useArticles;
